module.exports = function() {
  return new Worker(__webpack_public_path__ + "8fc72a0a0e454466ab5c.worker.js");
};